import { ReturnTaskReadable } from '@crm/api'
import { TaskFormElement } from '@crm/components/DynamicFields'
import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ModalProps } from 'antd/lib'

import { CompleteTaskForm } from './CompleteTaskForm'

const formName = 'complete-task-form'

type Props = {
  task: ReturnTaskReadable | null
  onCancel: () => void
} & ModalProps

export const CompleteTask = ({ task, onCancel, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      maskClosable={false}
      destroyOnHidden
      title={`${t('task.complete_form')}: ${task?.title}`}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      onCancel={onCancel}
      okButtonProps={{
        htmlType: 'submit',
        form: formName
      }}
      {...props}
    >
      <CompleteTaskForm
        task={task}
        elements={task?.type?.form as unknown as TaskFormElement[]}
        formName={formName}
        onSuccess={onCancel}
      />
    </Modal>
  )
}
